let fetchSeq = 0;

let actions = {
    fetchDocuments: async function ({ commit, state }, params) {
        const seq = ++fetchSeq;
        commit('SET_FETCHING', true);
        try {
            const fetchParams = { ...(params || state.lastParams) };

            if (params) {
                commit('SET_LAST_PARAMS', { ...params });
            }

            fetchParams.page = state.page;
            fetchParams.per_page = state.per_page;

            if (state.activeSort.column) {
                fetchParams.sort_column = state.activeSort.column;
                fetchParams.sort_direction = state.activeSort.direction || 'DESC';
            }

            const response = await axios.post('/documents/list', fetchParams);

            if (seq !== fetchSeq) return;

            const data = response.data;
            const docs = data.documents || [];

            let totalCount;
            if (data.total_count !== null && data.total_count !== undefined) {
                totalCount = data.total_count;
            } else {
                totalCount = docs.length >= state.per_page
                    ? (state.page * state.per_page) + 1
                    : (state.page - 1) * state.per_page + docs.length;
            }

            commit('UPDATE_ROWS', docs);
            commit('SET_TOTAL_COUNT', totalCount);
            return data;
        } finally {
            if (seq === fetchSeq) commit('SET_FETCHING', false);
        }
    },

    sortRows: async function ({ commit, dispatch }, sort_info) {
        const direction = sort_info.descending ? 'DESC' : 'ASC';
        commit('SET_SORT', { column: sort_info.column, direction });
        commit('SET_PAGINATION', { page: 1 });
        return dispatch('fetchDocuments');
    },

    updateRows: function ({ commit }, data) {
        if (!('rows' in data) && Array.isArray(data)) {
            data.rows = data;
        }
        if (!('filter_data' in data)) {
            data.filter_data = data.rows;
        }
        commit('UPDATE_ROWS', data.rows);
    },

    toggleInProgress: function ({ commit }) {
        commit('TOGGLE_IN_PROGRESS');
    },

    selectRow: function ({ commit, getters }, row_index) {
        commit('SELECT_ROW', getters.visibleRows[row_index]);
    },

    deselectRow: function ({ commit, getters }, row_index) {
        commit('DESELECT_ROW', getters.visibleRows[row_index]);
    },

    removeFilter: function ({ commit, state }, info) {
        commit('REMOVE_FILTER', info);
    },

    removeColumnFilters: function ({ commit, state }, column) {
        if (column && _.has(state.activeFilters, column)) {
            _.clone(state.activeFilters[column]).forEach(filter => {
                commit('REMOVE_FILTER', { column, filter })
            })
        }
    },

    addFilter: function ({ commit, state }, info) {
        commit('ADD_FILTER', info);
    },

    changeStartDate: function ({ commit }, date) {
        commit('CHANGE_START_DATE', date);
    },

    changeEndDate: function ({ commit }, date) {
        commit('CHANGE_END_DATE', date);
    },

    searchUpdated: function ({ commit }, updated = true) {
        commit('NEED_TO_SEARCH', updated);
    },

    checkSelectAllButton: function ({ commit }, checked = true) {
        commit('SELECT_ALL_CHECKED', checked);
    },

    toggleBalanceColumn: function ({ commit }, visible = true) {
        commit('SHOW_BALANCE_COLUMN', visible);
    },

    updateClientSampleTypes: function ({ commit }, items = []) {
        commit('UPDATE_CLIENT_SAMPLE_TYPES', items);
    },

    updateSelectedSampleTypes: function ({ commit }, selection = []) {
        commit('UPDATE_SELECTED_SAMPLE_TYPES', selection);
    },

    updateDocTypes: function ({ commit }, types = []) {
        commit('UPDATE_DOCUMENT_TYPES', types);
    },

    updateSelectedDocTypeCodes: function ({ commit }, codes = []) {
        commit('UPDATE_SELECTED_DOC_TYPE_CODES', codes);
    },

    updateUserAccountRoles: function ({ commit }, userAccountRoles = []) {
        commit('UPDATE_USER_ACCOUNT_ROLES', userAccountRoles);
    },

    updateUserIsSysAdmin: function ({ commit, state }, is_sys_admin = false) {
        commit('UPDATE_USER_IS_SYS_ADMIN', is_sys_admin);
    },

    setItemValue: function ({ commit }, params = {}) {
        commit('SET_ITEM_VALUE', params)
    },

    getReportFormats({ commit }, account_nbr) {
        commit('GET_REPORT_FORMATS', account_nbr)
    },

    emailReports({ commit }, params) {
        commit('EMAIL_REPORTS', params)
    },

    setOutliersOnly({ commit }, value) {
        commit('SET_OUTLIERS_ONLY', value);
    },

    setProjectPO: function ({ commit }, value) {
        commit('SET_PROJECT_PO', value);
    },

};

export default actions;


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/documents/actions.js